import GetLoading from "../../share/getLoading";
import React, { useEffect, useState, useRef } from "react";
import { Button, Space, Tabs, message, Avatar } from "antd";
import {
  IoCloudUploadOutline,
  IoCloudUploadSharp,
  IoIdCard,
} from "react-icons/io5";
import {
  ApiTwoTone,
  DeleteOutlined,
  IdcardOutlined,
  SettingOutlined,
  FileDoneOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { getCurrentUser } from "../../share/getProfile";
import { request } from "../../share/request";
import { openNotification } from "../../share/message";
import { linkPathIDCard } from "../../share/helper";
import BotTele from "../telegrambot/BotPage";
import UserSystem from "./UserSystem";

const CardProfilePhotoOrg = ({ idorg }) => {
  const inputRef_CardOrg_Profile_Template_v1 = useRef(null); // v1 is version 1.0

  const [
    CardOrg_Profile_Photo_Template_v1,
    setCardOrg_Profile_Photo_Template_v1,
  ] = useState(null);

  const [loadingSpin, setLoadingSpin] = useState(false);
  const [ID_PhotoBackgroundV1, setID_PhotoBackgroundV1] = useState();

  const [ImageCardOrg_Profile_Photo_v1, setImageCardOrg_Profile_Photo_v1] =
    useState(null);
  const getProfileOrg = getCurrentUser();
  useEffect(() => {
    setCardOrg_Profile_Photo_Template_v1(null);
    setID_PhotoBackgroundV1(null);
    setImageCardOrg_Profile_Photo_v1(null);

    if (idorg) {
      getImageLinkOrganization();
    }
  }, [idorg]);

  const getImageLinkOrganization = async () => {
    const param = new URLSearchParams({ org_code: idorg });
    try {
      const res = await request(
        "settingorgidcard?" + param.toString(),
        "get",
        {}
      );
      if (res && res.list_api) {
        const CardOrgProfilePhotoV1 = res.list_api.find(
          (item) => item.param === "org_card_profile"
        );
        if (CardOrgProfilePhotoV1) {
          setImageCardOrg_Profile_Photo_v1(
            linkPathIDCard + CardOrgProfilePhotoV1.imagelink
          );
          setID_PhotoBackgroundV1(CardOrgProfilePhotoV1.id);
        }
      }
    } catch (error) {
      console.error("Failed to fetch organization images:", error);
    }
  };

  const stylesCard = () => {
    return {
      width: 390,
      height: 550,
      border: "2px solid #ccc", // Adds a border
      borderRadius: "8px", // Rounds the corners
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)", // Adds shadow
      padding: "10px", // Adds padding inside the container
      backgroundColor: "#fff",
    };
  };

  const onHandleNew_Update_LeaveTemplateV1 = async () => {
    if (!CardOrg_Profile_Photo_Template_v1) return;
    const formData = new FormData();
    formData.append("id", ID_PhotoBackgroundV1);
    formData.append("org_code", idorg);
    formData.append("param", "org_card_profile");
    formData.append("image_name", CardOrg_Profile_Photo_Template_v1.name);
    formData.append("create_by", getProfileOrg.fullname);
    formData.append("file_image_card", CardOrg_Profile_Photo_Template_v1);
    setLoadingSpin(true);
    try {
      let method = ""; // Initialize method as let so we can reassign it
      method =
        ID_PhotoBackgroundV1 == null ||
        ID_PhotoBackgroundV1 == undefined ||
        ID_PhotoBackgroundV1 == ""
          ? "post"
          : "put";
      const res = await request("settingorgidcard", method, formData);
      if (res) {
        openNotification("success", "Success", "Template Saved Successfully");
        setCardOrg_Profile_Photo_Template_v1(null);
        getImageLinkOrganization();
        // setImageCardOrg_Profile_Photo_v1("");
      }
    } catch (error) {
      console.error("Save Template file failed:", error);
      openNotification("error", "Error", "Save failed");
    } finally {
      setLoadingSpin(false);
    }
  };
  const handFileChangeLeaveTemplateV1 = (e) => {
    try {
      const file = e.target.files[0];
      setCardOrg_Profile_Photo_Template_v1(file);
      setImageCardOrg_Profile_Photo_v1(URL.createObjectURL(file));
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div>
      {loadingSpin && (
        <div className="sprinSave">
          <GetLoading />
        </div>
      )}
      <div
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <div
          className="khmer-font"
          style={{
            color: "rebeccapurple",
            fontWeight: "bold",
            marginBottom: 10,
          }}
        >
          ក. Organization Prolfile Background V.1.0
        </div>

        <div
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {ImageCardOrg_Profile_Photo_v1 ? (
            <img
              src={ImageCardOrg_Profile_Photo_v1}
              alt="Front Preview"
              style={stylesCard()}
            />
          ) : (
            <di style={stylesCard()}>Loading....</di>
          )}
          <input
            type="file"
            ref={inputRef_CardOrg_Profile_Template_v1}
            style={{ display: "none" }}
            onChange={handFileChangeLeaveTemplateV1}
          />
          {CardOrg_Profile_Photo_Template_v1 && (
            <Button
              style={{ margin: "10px" }}
              type="primary"
              icon={<IoCloudUploadOutline />}
              onClick={onHandleNew_Update_LeaveTemplateV1}
            >
              Save Leave Template
            </Button>
          )}

          <div>
            <Space>
              <Button
                color="default"
                variant="solid"
                icon={<IoCloudUploadSharp />}
                style={{ marginTop: 10 }}
                onClick={() =>
                  inputRef_CardOrg_Profile_Template_v1.current.click()
                }
              >
                Upload
              </Button>
              {ImageCardOrg_Profile_Photo_v1 && (
                <Button
                  color="danger"
                  variant="solid"
                  style={{ marginTop: 10 }}
                  icon={<DeleteOutlined />}
                />
              )}
            </Space>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardProfilePhotoOrg;
